
import { Box, Grid } from "@mui/material";
import { DisenioPaginas } from "../../layout";
import { useEncubadoraQuery } from "../../../hooks";
import { BuscadorSoloValor, CargandoMedio, TablaListIncubadora } from "../../components";



export const ListadoEncubadora = () => {

    const { encubadoraListQuery, page, termino, chagePage, chageTermino } = useEncubadoraQuery();
    

    
    return (

        <DisenioPaginas titulo="Listado Incubadoras" url="add/encubadora">
            {(encubadoraListQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Incubadoras..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar incubadora...' place='Buscar x nombre...'
                />
                <TablaListIncubadora data={encubadoraListQuery.data || []} chagePage={chagePage} page={page} />
                </>
            }

            <Box sx={{height:30}} />
        </DisenioPaginas>

    )
}
